import React, { FunctionComponent } from 'react'
import { UsersTable } from '../components/UsersTable'
import { useWideContent } from '../components/Navigation/WideContentContext'
import { legacyLayoutProps } from './constants'

export const ManageUsers: FunctionComponent = () => {
  useWideContent()

  return <UsersTable {...legacyLayoutProps} />
}
